// Format time like 9:00 am-4:00 pm, ................
const formatTime = (timeString) => {
  // Convert 24-hour time to 12-hour time format with AM/PM
  const [hours, minutes] = timeString?.split(":")?.map(Number);
  const period = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes === 0 ? "" : `:${minutes}`;
  return `${formattedHours}${formattedMinutes} ${period}`;
};

export const formatTimeSlots = (timeSlots) => {
  return timeSlots
    .map((slot) => {
      const startTime = formatTime(slot?.product_start_time);
      const endTime = slot?.product_end_time
        ? formatTime(slot?.product_end_time)
        : "No end date";
      return `${startTime} ${slot?.product_end_time ? `- ${endTime}` : ""}`;
    })
    .join(" , "); // Join multiple time slots with comma
};

export const formatTimeSlotsV2 = (timeSlots) => {
  return timeSlots
    .map((slot) => {
      const startTime = formatTime(slot?.product_start_time);
      const endTime = slot?.product_end_time
        ? formatTime(slot?.product_end_time)
        : "No end date";
      return `${startTime} ${slot?.product_end_time ? `to ${endTime}` : ""}`;
    })
    .join(" , "); // Join multiple time slots with comma
};

export const generateTimeOptions = () => {
  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const value = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      const label = new Date(0, 0, 0, hour, minute).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      timeOptions.push({ value, label });
    }
  }
  return timeOptions;
};
// Helper function to convert 24-hour time to 12-hour format with AM/PM
export const convertTo12HourFormat = (time24) => {
  if (!time24) {
    return "";
  } else {
    const [hour, minute] = time24?.split(":");
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12; // Convert '0' or '12' hour to 12
    return `${hour12}:${minute} ${period}`;
  }
};
